// extracted by mini-css-extract-plugin
export default {"urlInput":"LZqw4NOYrGVRJoXWj+06pg=="};